/* PV back-to-top progress ring (s316, backtotop-redesign-2026-06-23.md)
   Injects a decorative SVG progress ring into the native Halo <back-to-top-button>
   and drives stroke-dashoffset from scroll %. The native up-arrow is KEPT (CSS recolors
   it) so the control still works if this JS fails. Codex review applied:
   - [MUST] do NOT change the element's role (native role=button stays); ring is aria-hidden,
     decorative — NOT a progressbar (would break "activate to go to top" for screen readers).
   - [SHOULD] MutationObserver repairs the ring if Halo re-renders, and recomputes progress
     after AJAX SHOW MORE grows the page (scrollHeight changes without a scroll event).
   Reduced-motion: ring still reflects scroll position (not autonomous motion); CSS drops the
   stroke transition under prefers-reduced-motion. */
/* s458 CWV FIX-2 v2 (T22 forced-reflow attribution + Codex r1 MUST-3/SHOULD-3):
   - scroll-frame update() no longer reads scrollHeight/clientHeight/innerHeight (forced
     layout per frame) — geometry is measured in refresh() and cached.
   - refresh scheduling = trailing 200ms debounce WITH 1000ms maxWait: mutation storms
     collapse but sustained mutations cannot starve refresh indefinitely.
   - cache invalidation signals beyond childList mutations: ResizeObserver on
     document.body (catches font late-swap / class-driven / details[open] height changes),
     document.fonts.ready (one-shot), pageshow (bfcache restore), window resize.
     Our own writes (fixed-position button class + SVG stroke) do not change body height,
     so the ResizeObserver cannot self-trigger a loop.
   - update() skips disconnected nodes; refresh() prunes them (detached-host leak).
   Behavior, roles and aria are unchanged. */
(function () {
  var R = 16.5, C = 2 * Math.PI * R, nodes = [], ticking = false;
  var cachedMax = 0, cachedShowAt = 400;

  function hasRing(btn) { return !!btn.querySelector('.pv-btt-ring'); }

  function build(btn) {
    if (btn.dataset.pvBtt === '1' && hasRing(btn)) return; // already built & intact
    var ns = 'http://www.w3.org/2000/svg';
    var ring = document.createElementNS(ns, 'svg');
    ring.setAttribute('class', 'pv-btt-ring');
    ring.setAttribute('viewBox', '0 0 36 36');
    ring.setAttribute('aria-hidden', 'true');
    ring.setAttribute('focusable', 'false');
    var track = document.createElementNS(ns, 'circle');
    track.setAttribute('class', 'pv-btt-track');
    track.setAttribute('cx', '18'); track.setAttribute('cy', '18'); track.setAttribute('r', R);
    var prog = document.createElementNS(ns, 'circle');
    prog.setAttribute('class', 'pv-btt-prog');
    prog.setAttribute('cx', '18'); prog.setAttribute('cy', '18'); prog.setAttribute('r', R);
    prog.style.strokeDasharray = C;
    prog.style.strokeDashoffset = C;
    ring.appendChild(track); ring.appendChild(prog);
    btn.insertBefore(ring, btn.firstChild);
    btn.dataset.pvBtt = '1';
    // Keep native role=button; only ensure an accessible name. Do NOT add progressbar role.
    if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', 'Back to top');
    nodes = nodes.filter(function (n) { return n.btn !== btn; });
    nodes.push({ pr: prog, btn: btn });
  }

  function scan() {
    nodes = nodes.filter(function (n) { return n.btn.isConnected; }); // prune detached hosts
    var list = document.querySelectorAll(
      'back-to-top-button[data-scroll-to-top], back-to-top-button.recently-viewed-icon');
    for (var i = 0; i < list.length; i++) build(list[i]);
  }

  function measure() { // layout reads live here only (refresh paths), not per scroll frame
    var de = document.documentElement;
    cachedMax = de.scrollHeight - de.clientHeight;
    cachedShowAt = Math.max(400, window.innerHeight * 0.6);
  }

  function update() {
    var sc = window.pageYOffset || document.documentElement.scrollTop || 0;
    var p = cachedMax > 0 ? Math.min(1, Math.max(0, sc / cachedMax)) : 0;
    var off = C * (1 - p);
    // appear-after-scroll: show only past ~0.6 viewport (NN/g: don't show on short/near-top pages)
    var show = sc > cachedShowAt;
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].btn.isConnected) continue; // skip detached (pruned on next refresh)
      nodes[i].pr.style.strokeDashoffset = off;
      nodes[i].btn.classList.toggle('pv-btt-on', show);
    }
  }

  function frame(fn) { if (!ticking) { ticking = true; requestAnimationFrame(function () { fn(); ticking = false; }); } }
  function onScroll() { frame(update); }
  function refresh() { scan(); measure(); update(); } // re-scan (repair) + re-measure + recompute

  // trailing 200ms debounce + 1000ms maxWait: storms collapse, but can't starve refresh
  var moT = null, firstPendingAt = 0;
  function refreshDebounced() {
    var now = Date.now();
    if (!firstPendingAt) firstPendingAt = now;
    if (moT) {
      if (now - firstPendingAt >= 1000) return; // maxWait timer already running down
      clearTimeout(moT);
    }
    var wait = Math.min(200, Math.max(0, firstPendingAt + 1000 - now));
    moT = setTimeout(function () { moT = null; firstPendingAt = 0; refresh(); }, wait);
  }

  function init() {
    refresh();
    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(refreshDebounced);
      var grid = document.querySelector('#CollectionProductGrid, .halo-grid-content, .collection-grid, #MainContent') || document.body;
      mo.observe(grid, { childList: true, subtree: true });
      var wrap = document.getElementById('halo-recently-viewed-wrap');
      if (wrap) mo.observe(wrap, { childList: true });
    }
    if (typeof ResizeObserver === 'function' && document.body) {
      // catches height changes with no childList mutation (font swap / class toggles /
      // details[open]); our writes never resize body, so no feedback loop
      new ResizeObserver(refreshDebounced).observe(document.body);
    }
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(refreshDebounced);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', refresh);
  window.addEventListener('pageshow', refreshDebounced);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', refreshDebounced, { passive: true });
})();
